// extracted by mini-css-extract-plugin
module.exports = {"root":"DialogCloseIcon_root__3jbzU"};